module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAMAAADEfo0+AAAAAXNSR0IArs4c6QAAAFdQTFRFAAAAAP//AP/VANvbAObMAOq/ANjEAOPGANvCANm9AN27AN26ANq7ANe7ANa7ANa5ANe5ANe6ANa6ANa5ANe5ANe6ANe5ANa5ANe5ANe5ANe5ANe6ANa5jCBNZAAAABx0Uk5TAAMGBwoMDRIVGx4lKXSKnaSutru+x8zU2N/j6X0QEiUAAABoSURBVBjT3Y5LFkAwAAND/alSf+b+57QoD1eQVTKbjCRJsmD1zl9BnDwgiaV0mPIb5NOQysNSBlAu4NXssNUWbL3B3kjVCkcH3QFrJUnFzJW5CD/ZGPaY3c+mB+jN4xU5cNFHtW2vcgL83AxXZYe4kAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico/down.png
// module id = 7Ky+
// module chunks = 1